import api from './api'

const walletService = {
  addCash: async (data) => {
    const response = await api.post('/admin/wallet/cash/add', data)
    return response.data
  },
  subtractCash: async (data) => {
    const response = await api.post('/admin/wallet/cash/subtract', data)
    return response.data
  },
  addCredit: async (data) => {
    const response = await api.post('/admin/wallet/credit/add', data)
    return response.data
  },
  // Hierarchy settlement — direct child ka pending clear (points +/- signed)
  settlePoints: async (data) => {
    const response = await api.post('/admin/wallet/points/settle', data)
    return response.data
  },
  // Naya deposit — direct child ko points (credit + all_point + ledger entry ke saath)
  addDeposit: async (data) => {
    const response = await api.post('/admin/wallet/deposit/add', data)
    return response.data
  },
  // Naya withdraw — direct child se points wapas (deposit ka ulta, ledger entry ke saath)
  withdrawChild: async (data) => {
    const response = await api.post('/admin/wallet/withdraw', data)
    return response.data
  },
  // Owner Add Balance — sirf owner, apne hi wallet me (inr + credit + all_point + ledger)
  addOwnerBalance: async (data) => {
    const response = await api.post('/admin/wallet/owner/add-balance', data)
    return response.data
  },
}

export default walletService
